import { render, staticRenderFns } from "./CreateESGScopeConversionModalTemp.vue?vue&type=template&id=a808eb70&scoped=true"
import script from "./CreateESGScopeConversionModalTemp.vue?vue&type=script&lang=js"
export * from "./CreateESGScopeConversionModalTemp.vue?vue&type=script&lang=js"
import style0 from "./CreateESGScopeConversionModalTemp.vue?vue&type=style&index=0&id=a808eb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a808eb70",
  null
  
)

export default component.exports